import { render, staticRenderFns } from "./tit-wrap-primary.vue?vue&type=template&id=1e613f68&scoped=true&"
import script from "./tit-wrap-primary.vue?vue&type=script&lang=js&"
export * from "./tit-wrap-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e613f68",
  null
  
)

export default component.exports